/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class FileDownloadControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fileDownloadControllerDownloadFile
   */
  static readonly FileDownloadControllerDownloadFilePath = '/files/{filename}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadFile$Response(params: {
    filename: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FileDownloadControllerService.FileDownloadControllerDownloadFilePath, 'get');
    if (params) {
      rb.path('filename', params.filename, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `downloadFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadFile(params: {
    filename: string;
  }): Observable<Blob> {

    return this.downloadFile$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation fileDownloadControllerListFiles
   */
  static readonly FileDownloadControllerListFilesPath = '/files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFiles$Response(params?: {
    folder?: string;
  }): Observable<StrictHttpResponse<Array<{ 'name'?: string, 'folder'?: boolean }>>> {

    const rb = new RequestBuilder(this.rootUrl, FileDownloadControllerService.FileDownloadControllerListFilesPath, 'get');
    if (params) {
      rb.query('folder', params.folder, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ 'name'?: string, 'folder'?: boolean }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFiles(params?: {
    folder?: string;
  }): Observable<Array<{ 'name'?: string, 'folder'?: boolean }>> {

    return this.listFiles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ 'name'?: string, 'folder'?: boolean }>>) => r.body as Array<{ 'name'?: string, 'folder'?: boolean }>)
    );
  }

}
